import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "landing-header",
  class: "w-full m-2 mb-5 flex justify-between"
}
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = {
  id: "website title",
  class: "text-md mx-5 font-medium flex items-end"
}
const _hoisted_5 = {
  id: "language switcher",
  class: "col-start-1 flex"
}
const _hoisted_6 = {
  id: "landing-main",
  class: "w-full bg-landing bg-contain bg-no-repeat px-2"
}
const _hoisted_7 = { class: "w-full grid grid-cols-3 mt-10" }
const _hoisted_8 = { class: "col-start-1" }
const _hoisted_9 = {
  id: "text-div",
  class: "text-left text-xl font-bold"
}
const _hoisted_10 = { class: "col-start-1 col-span-3 mx-7 my-5 mb-20" }
const _hoisted_11 = {
  id: "landing-footer",
  class: "w-full bg-gray-100 px-2"
}
const _hoisted_12 = {
  id: "footer-column",
  class: "flex flex-col items-start"
}
const _hoisted_13 = { class: "font-bold mb-5" }
const _hoisted_14 = {
  href: "https://www.dbcargo.com/rail-de-de/agb",
  target: "_blank"
}
const _hoisted_15 = {
  href: "https://www.dbcargo.com/rail-de-de/impressum-4970666",
  target: "_blank"
}
const _hoisted_16 = {
  href: "https://www.dbcargo.com/rail-de-de/Datenschutz/datenschutzhinweise-4983542",
  target: "_blank"
}
const _hoisted_17 = {
  href: "https://www.dbcargo.com/rail-de-de/link2rail",
  target: "_blank"
}
const _hoisted_18 = {
  href: "https://www.dbcargo.com/rail-de-de",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DbLogo = _resolveComponent("DbLogo")!
  const _component_LocaleChanger = _resolveComponent("LocaleChanger")!
  const _component_CodeComponent = _resolveComponent("CodeComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DbLogo),
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-[1.7rem] font-bold text-left" }, "Cargo", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("landing.apptitle")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_LocaleChanger, { landingPage: true })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("landing.motto")), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            id: "red-line",
            class: "border-b-8 mb-36 border-red-600 w-[77.07px] rounded-md"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_CodeComponent)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("landing.footer.terms_and_conditions")), 1),
        _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("landing.footer.general_terms_and_conditions")), 1),
        _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("landing.footer.legal_info")), 1),
        _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("landing.footer.privacy")), 1),
        _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t("landing.footer.e-services")), 1),
        _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.$t("landing.footer.website")), 1),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex flex-col justify-end text-gray-400 mt-5" }, " © 2024 DB Cargo AG ", -1))
      ])
    ])
  ], 64))
}